import tessPic from "@/public/images/artists/tess.png";
import { Artist } from "@/types/types";

export const tess = {
  id: "37",
  name: "Tess",
  image: tessPic,
  description: `Introducing "Tess," the exceptional EDM vocalist and house artist. With a voice that seamlessly melds with your beats, Tess brings an unmatched energy and versatility to the dance and pop stage.`,
  previewUrl:
    "https://public-assets.audimeestorage.com/artistPreviews%2Ftess-preview.mp3",
  meta: {
    free: false,
    new: false,
  },
  filters: {
    gender: "Female",
    tags: {
      primary: ["Dance", "Pop"],
      secondary: ["Singer", "Club", "House"],
    },
    pitchRange: {
      categories: {
        low: "Mid",
        high: "High",
      },
      specific: {
        low: 55,
        high: 71,
      },
    },
  },
} as const satisfies Artist;
